/** 列表前端分页：配合 ListPagination，数据源为 this.list */
export default {
  data() {
    return {
      page: 1,
      pageSize: 15
    }
  },
  computed: {
    pageList() {
      const list = this.list || []
      const start = (this.page - 1) * this.pageSize
      return list.slice(start, start + this.pageSize)
    },
    listTotal() {
      return (this.list || []).length
    }
  },
  watch: {
    list() {
      const max = Math.max(1, Math.ceil(this.listTotal / this.pageSize) || 1)
      if (this.page > max) this.page = max
    }
  },
  methods: {
    onPageChange(p) {
      this.page = p
    },
    onPageSizeChange(s) {
      this.pageSize = s
      this.page = 1
    }
  }
}
